import { j as a } from "./jsx-runtime-3tyXYecC.mjs";
import fe, { useRef as Ie, Component as Le, createRef as re, isValidElement as ue } from "react";
import { l as O } from "./lodash-5ofSKtz3.mjs";
import { I as _e } from "./icon-CvGUqXUP.mjs";
import { c as A } from "./index-DkZ16bcJ.mjs";
import { d as Be } from "./index-DspsydPg.mjs";
import { F as je } from "./flex-Cc3osQLf.mjs";
import { C as we } from "./checkbox-DiWnVoeQ.mjs";
import { L as ae } from "./layout-box-DFBM-kSI.mjs";
import { S as se } from "./screen-reader-only-text-B-XgpPEP.mjs";
import { F as He } from "./fabric-icon-CNOLIwc_.mjs";
import { T as ze } from "./tooltip-Cy1xtUCm.mjs";
import { f as P } from "./index-LyFokDcn.mjs";
import { I as be } from "./icon-button-BxDvkq_l.mjs";
import { i as Ae } from "./enhance-anchor-props-DgCJ7ag3.mjs";
import { A as Y } from "./tss-DN0acMKN.mjs";
import { k as Te } from "./emotion-react.browser.esm-BdEGsKDn.mjs";
import { M as V, d as N } from "./constants-CnFYFetN.mjs";
import { I as ne } from "./icon-v2-DGtVEk7e.mjs";
import { _ as Ee } from "./composeRefs-YONvD-rx.mjs";
import { L as We } from "./loader-CJQkrVUR.mjs";
const xe = (k) => fe.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 5 9", width: "5", height: "9" }, k),
  fe.createElement("path", { d: "M5 4.5L1.07324e-07 9L0 5.96244e-08L5 4.5Z" })
);
xe.displayName = "Triangle9x5";
function Pe(k, y, e) {
  return [...k].sort((r, i) => {
    e || ([r, i] = [i, r]);
    const o = y(r), t = y(i);
    return o < t ? -1 : t < o ? 1 : 0;
  });
}
const Ke = (k) => {
  const { biId: y, rowIsSelected: e, rowSelectionIsDisabled: r = !1, rowKey: i } = k;
  return /* @__PURE__ */ a.jsx(ae, { marginTop: "2px", width: "16px", children: /* @__PURE__ */ a.jsx(
    we,
    {
      biId: y && `${y}-checkbox-cell-${i}`,
      checked: !!e,
      disabled: r,
      id: `fabricTableCheckboxCell-${i}`,
      label: /* @__PURE__ */ a.jsx(se, { children: window.jQuery ? $.__("Select row %s", i) : `Select row ${i}` }),
      onChange: O.noop,
      value: ""
    }
  ) });
}, Fe = (k) => {
  const {
    biId: y,
    classes: e,
    checked: r,
    onToggleAll: i,
    headerVariant: o,
    stickyLeft: t,
    stickyHeader: l,
    stickyLeftBorder: s,
    stickyLeftScreen: d,
    left: u,
    stickyHeaderTop: m,
    uuid: n
  } = k, p = `fabricTableCheckboxHeader-${n}`, c = A({
    [e.header]: !0,
    [e.stickyTop]: l,
    [e.stickyLeft]: t,
    [e.stickyLeftBorder]: s,
    [e.stickyLeftScreen]: d,
    [e.minimalRightPadding]: !0,
    [e.whiteHeaderVariant]: o === "white"
  }), f = {
    left: u,
    top: m || void 0,
    width: "36px"
  };
  return /* @__PURE__ */ a.jsx("th", { className: c, style: f, children: /* @__PURE__ */ a.jsx(ae, { marginTop: "2px", width: "16px", children: /* @__PURE__ */ a.jsx(
    we,
    {
      biId: y && `${y}-select-all`,
      checked: !!r,
      id: p,
      label: /* @__PURE__ */ a.jsx(se, { children: window.jQuery ? $.__("Select all rows") : "Select all rows" }),
      onChange: i,
      value: ""
    }
  ) }) }, p);
};
function Me({ icon: k, action: y, href: e, newTab: r, tooltipTitle: i, tooltipContent: o, biId: t }) {
  const l = Ie(null), s = `${i || ""} ${o || ""}`.trim() || void 0, d = e && typeof e == "string", u = d && (Ae(e) || r);
  return /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
    (i || o) && /* @__PURE__ */ a.jsx(ze, { anchorRef: l, content: o, title: i }),
    P.ifFeature(
      "encore",
      /* @__PURE__ */ a.jsx(
        be,
        {
          ariaLabel: s,
          "data-bi-id": t,
          disabled: !y && !e,
          floatingIcon: !0,
          href: d ? e : void 0,
          icon: k,
          onClick: y,
          ref: l,
          size: "small",
          target: u ? "_blank" : void 0,
          type: "button",
          variant: "outlined"
        }
      ),
      /* @__PURE__ */ a.jsx(
        be,
        {
          ariaLabel: s,
          "data-bi-id": t,
          disabled: !y && !e,
          floatingIcon: !0,
          href: d ? e : void 0,
          icon: typeof k == "string" ? /* @__PURE__ */ a.jsx(He, { "aria-hidden": !0, name: k }) : k,
          onClick: y,
          ref: l,
          rel: u ? "noopener noreferrer" : void 0,
          size: "teenie",
          target: u ? "_blank" : void 0,
          type: "button"
        }
      )
    )
  ] });
}
function Oe(k) {
  const { actions: y, classes: e, row: r } = k, i = y(r);
  return /* @__PURE__ */ a.jsx("div", { className: e.cellActions, children: i.length > 0 && i.map((o, t) => {
    const { icon: l, action: s, href: d = "", key: u, newTab: m, tooltipTitle: n, tooltipContent: p, biId: c } = o, f = l, w = typeof l == "string" ? l : void 0, g = typeof l == "string" ? l.indexOf("PLACEHOLDER") > -1 : !1, S = u || `action-${t}`;
    if (g)
      return /* @__PURE__ */ a.jsx(ae, { height: "32px", padding: "0 8px", width: `${De(w)}px` }, S);
    if (f)
      return /* @__PURE__ */ a.jsx(
        Me,
        {
          action: s,
          biId: c,
          href: d,
          icon: l,
          newTab: m,
          tooltipContent: p,
          tooltipTitle: n
        },
        S
      );
  }) });
}
function De(k = "") {
  const y = /PLACEHOLDER-(\d+)/.exec(k);
  return y ? y[1] : "0";
}
const Ve = (k, y, e) => {
  var w, g, S;
  const { borderRadiuses: r, constructs: i, mixins: o, palette: t, spacing: l, typography: s, mode: d } = k, { stickyColumn: u = !1, stickyGroupHeaderTop: m, tabularNums: n = !0 } = y, p = Te({
    "0%": {
      opacity: 0
    },
    "100%": {
      opacity: 1
    }
  }), c = {
    root: {
      fontSize: s.medium.fontSize,
      lineHeight: s.medium.lineHeight,
      "--fab-table-sticky-group-header-top": "44px",
      boxSizing: "border-box",
      width: "100%",
      borderSpacing: 0,
      gridArea: "table",
      isolation: "isolate",
      fontVariantNumeric: n === !0 ? "tabular-nums" : "inherit",
      [`&.${e.fixedLayout}`]: {
        tableLayout: "fixed"
      },
      [`& > *:not(&.${e.tbodyForLoader})`]: {
        transition: "opacity 0.15s ease-in-out"
      },
      [`&.${e.tableLoading}`]: {
        position: "relative",
        [`& > *:not(&.${e.tbodyForLoader})`]: {
          opacity: 0.4
        }
      },
      [`&.${e.tableWithRowHover} .${e.row}:hover, &.${e.tableWithRowHover} .${e.row}:focus-within, &.${e.tableWithRowHover} .${e.row}:has([aria-expanded="true"])`]: {
        backgroundColor: i.surface.neutral.xWeak
      },
      [`&.${e.tableWithZebraStripes} .${e.row}:nth-child(even):not(.${e.rowSelected}):not(:hover)`]: {
        backgroundColor: o.alpha(t.grey[50], 0.5)
      }
    },
    fixedLayout: {},
    tbodyForLoader: {},
    tableLoading: {},
    tableWithRowHover: {},
    tableWithZebraStripes: {},
    caption: {
      fontSize: 0,
      height: 0,
      overflow: "hidden"
    },
    wrap: {
      borderRadius: l(1),
      display: "grid",
      outline: d === V.Dye ? `1px solid ${N.main}` : void 0,
      // Make the Table create its own stacking context
      zIndex: 0,
      "&:focus": {
        boxShadow: `0 0 0 2px ${o.alpha(i.surface.primary.medium, 0.35)}`
      }
    },
    wrapOverflow: {
      overflow: "auto"
    },
    innerWrap: {
      display: "grid",
      gridTemplateColumns: "0 auto 0",
      gridTemplateRows: "auto",
      // Yes... the " inside ' is necessary...
      gridTemplateAreas: '"left-scroll-screen table right-scroll-screen"'
    },
    stickyIndicators: {
      position: "sticky",
      display: "flex",
      justifyContent: "space-between",
      top: 0,
      height: 0,
      opacity: 0,
      pointerEvents: "none"
    },
    stickyIndicator: {
      top: 0,
      width: "10px",
      height: "10px",
      backgroundColor: "red",
      position: "sticky"
    },
    loaderCell: {
      padding: 0
    },
    loader: {
      position: "absolute",
      top: 0,
      right: 0,
      left: 0,
      bottom: 0,
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    },
    leftScrollIndicator: {
      gridArea: "left-scroll-screen",
      alignSelf: "stretch",
      position: "sticky",
      left: 0,
      pointerEvents: "none",
      zIndex: 200,
      "&:before": {
        // borderLeft: `2px solid ${ palette.gray[400] }`,
        content: '""',
        height: "100%",
        position: "absolute",
        top: 0,
        bottom: 0,
        width: "48px"
      }
    },
    leftScrollIndicatorWithScreen: {
      "&:before": {
        background: `linear-gradient(90deg, ${t.common.white} 0%, transparent 100%)`
      }
    },
    rightScrollIndicator: {
      gridArea: "right-scroll-screen",
      alignSelf: "stretch",
      position: "sticky",
      right: 0,
      pointerEvents: "none",
      zIndex: 200,
      "&:before": {
        // borderRight: `2px solid ${ palette.gray[400] }`,
        content: '""',
        height: "100%",
        position: "absolute",
        top: 0,
        right: 0,
        bottom: 0,
        width: "48px"
      }
    },
    rightScrollIndicatorWithScreen: {
      "&:before": {
        background: `linear-gradient(270deg, ${t.common.white} 0%, transparent 100%)`
      }
    },
    row: {
      borderBottom: `1px solid ${t.grey[100]}`,
      transition: "background-color 0.15s ease-in-out",
      outline: d === V.Dye ? `1px solid ${N.main}` : void 0,
      '&:has([aria-expanded="true"])': {
        [`.${e.cellMask}`]: {
          opacity: 1
        }
      },
      [`&:hover .${e.cellMask}`]: {
        opacity: 1
      },
      // START FF Fix
      // The following two rules have to be split up because otherwise FF chokes on the :has and ruins the entire selector (including the selector before the comma)
      // if you make changes to one, you have to make changes to the other
      [`&:hover .${e.stickyRight}`]: {
        position: "sticky",
        right: 0,
        zIndex: 100,
        "&:before": {
          background: `linear-gradient(90deg, transparent 0, ${t.common.white} 40px)`,
          content: '""',
          position: "absolute",
          width: "calc(100% + 40px)",
          top: 0,
          bottom: 0,
          right: 0
        }
      },
      [`&:has([aria-expanded="true"]) .${e.stickyRight}`]: {
        position: "sticky",
        right: 0,
        zIndex: 100,
        "&:before": {
          background: `linear-gradient(90deg, transparent 0, ${t.common.white} 40px)`,
          content: '""',
          position: "absolute",
          width: "calc(100% + 40px)",
          top: 0,
          bottom: 0,
          right: 0
        }
      },
      // End FF Fix
      [`&.${e.rowEmphasized}`]: {
        fontWeight: s.fontWeightSemibold
      },
      [`&.${e.rowHighlighted}, &.${e.rowSelected}, &.${e.rowHighlighted} > .${e.stickyLeft}, &.${e.rowSelected} > .${e.stickyLeft}`]: {
        backgroundColor: t.primary.lightest
      },
      [`&.${e.rowCollapsible} td:first-child`]: {
        paddingLeft: "34px"
        // line up with text of collapsible parent, which has 16px left padding + 10px icon + 8px gap
      },
      [`&.${e.removeBottomBorder}`]: {
        borderBottom: "none"
      }
    },
    removeBottomBorder: {
      "&:last-of-type": {
        borderBottom: "none"
      }
    },
    rowEmphasized: {},
    rowHighlighted: {},
    rowSelected: {},
    rowCollapsible: {},
    header: {
      boxSizing: "border-box",
      position: "relative",
      textAlign: "left",
      verticalAlign: "top",
      backgroundColor: d === V.Dye ? N.lighter : t.grey[100],
      color: t.grey[800],
      fontWeight: s.fontWeightSemibold,
      padding: l(1.5, 2),
      transition: "background-color 0.15s ease-in-out",
      borderColor: "transparent",
      "&:first-of-type": {
        borderRadius: `${r[200]} 0 0 ${r[200]}`
      },
      "&:last-of-type": {
        borderRadius: `0 ${r[200]} ${r[200]} 0`
      },
      "&:only-of-type": {
        // If there is only one column, the border radius should be applied to all corners
        borderRadius: r[200]
      },
      [`&.${e.minimalRightPadding}`]: {
        paddingRight: l(0.5)
      },
      [`&.${e.noVerticalPadding}`]: {
        paddingTop: 0,
        paddingBottom: 0
      },
      [`&.${e.noHorizontalPadding}`]: {
        paddingLeft: 0,
        paddingRight: 0
      },
      [`&.${e.alignCenter}`]: {
        textAlign: "center"
      },
      [`&.${e.alignRight}`]: {
        textAlign: "right"
      },
      [`.${e.headless} &`]: {
        borderBottom: `1px solid ${t.grey[100]}`,
        fontSize: 0,
        height: 0,
        lineHeight: 0,
        paddingTop: 0,
        paddingBottom: 0,
        pointerEvents: "none"
      },
      [`.${e.headless}:has(tr:first-child > .${e.cellGroup}) &`]: {
        borderBottom: "none"
      },
      [`&.${e.stickyTop}`]: {
        position: "sticky",
        top: 0,
        zIndex: 120
      },
      [`&.${e.stickyLeft}`]: {
        position: "sticky",
        left: 0,
        zIndex: 130
      },
      [`&.${e.stickyLeftBorder}:before`]: {
        backgroundColor: t.gray[200],
        content: '""',
        position: "absolute",
        top: 0,
        right: 0,
        bottom: "-1px",
        width: "2px"
      },
      [`&.${e.stickyLeftScreen}:after`]: {
        background: `linear-gradient(90deg, ${t.common.white} 0%, transparent 100%)`,
        boxSizing: "border-box",
        content: '""',
        position: "absolute",
        top: 0,
        right: "-46px",
        width: "46px",
        pointerEvents: "none",
        opacity: 1,
        bottom: 0
      },
      [`&.${e.sortableHeader}`]: {
        "&:hover": {
          cursor: "pointer"
        },
        [`&:not(&.${e.whiteHeaderVariant}):hover`]: {
          zIndex: 1,
          "&:before": {
            animation: `${p} 0.15s`,
            backgroundColor: t.gray[200],
            borderRadius: r[200],
            content: '""',
            display: "block",
            height: "100%",
            left: 0,
            pointerEvents: "none",
            position: "absolute",
            top: 0,
            width: "100%",
            zIndex: -1
          }
        }
      },
      [`&.${e.whiteHeaderVariant}`]: {
        borderBottom: `1px solid ${t.grey[300]}`,
        backgroundColor: t.common.white
      }
    },
    headless: {
      [`.${e.root}&`]: {
        "--fab-table-sticky-group-header-top": "0px"
      }
    },
    whiteHeaderVariant: {},
    // @startCleanup encore
    noBottomBorderRadius: {},
    // @endCleanup encore
    sortableHeader: {
      [`&:has(.${e.sortIcon}:focus-visible)`]: {
        // This is the styles for when a sortable header cell is tabbed to
        "&::after": {
          borderRadius: "inherit",
          bottom: "2px",
          boxShadow: `0px 0px 0px 2px ${o.alpha(i.surface.primary.medium, 0.8)}`,
          content: '""',
          left: "2px",
          overflow: "visible",
          position: "absolute",
          right: "2px",
          top: "2px"
        }
      }
    },
    sortIcon: {
      // Styles the sort button and makes it cover the whole th element
      backgroundColor: "transparent",
      border: "0px solid transparent",
      borderRadius: "inherit",
      cursor: "pointer",
      padding: "0px"
    },
    hideSortIcon: {
      opacity: 0
    },
    sortableHeaderCell: {
      alignItems: "center",
      display: "flex",
      gap: l(1),
      [`&:has(.${e.sortIcon}:focus-visible) .${e.hideSortIcon}`]: {
        opacity: 1
      }
    },
    cell: {
      boxSizing: "border-box",
      textAlign: "left",
      verticalAlign: "top",
      color: t.grey[1e3],
      padding: l(2),
      position: "relative",
      [`&.${e.minimalRightPadding}`]: {
        paddingRight: l(0.5)
      },
      [`&.${e.noVerticalPadding}`]: {
        paddingTop: 0,
        paddingBottom: 0
      },
      [`&.${e.noHorizontalPadding}`]: {
        paddingLeft: 0,
        paddingRight: 0
      },
      [`&.${e.alignCenter}`]: {
        textAlign: "center"
      },
      [`&.${e.alignRight}`]: {
        textAlign: "right"
      },
      [`&.${e.verticalAlign}`]: {
        verticalAlign: "middle"
      },
      [`&.${e.stickyLeft}`]: {
        position: "sticky",
        left: 0,
        background: t.common.white,
        backgroundClip: "padding-box",
        transition: "background-color 0.15s ease-in-out",
        // animation for background when selected/highlighted
        zIndex: 90
      },
      [`&.${e.stickyLeftBorder}:before`]: {
        backgroundColor: t.gray[200],
        content: '""',
        position: "absolute",
        top: 0,
        right: 0,
        bottom: "-1px",
        width: "2px"
      },
      [`&.${e.stickyLeftScreen}:after`]: {
        background: `linear-gradient(90deg, ${t.common.white} 0%, transparent 100%)`,
        boxSizing: "border-box",
        content: '""',
        position: "absolute",
        top: 0,
        right: "-46px",
        width: "46px",
        pointerEvents: "none",
        opacity: 1,
        bottom: 0
      },
      [`&.${e.cellGroup}`]: {
        backgroundColor: d === V.Dye ? N.lightest : void 0,
        borderBottom: "none",
        color: t.grey[800],
        fontWeight: s.fontWeightSemibold,
        padding: 0,
        paddingTop: l(0.5),
        position: "unset"
      },
      [`&.${e.noBottomBorder}`]: {
        borderBottom: "none"
      }
    },
    collapsibleRowIcon: {
      position: "absolute",
      left: 0,
      top: "50%",
      transform: "translateY(-50%)"
    },
    minimalRightPadding: {},
    noVerticalPadding: {},
    noHorizontalPadding: {},
    alignCenter: {},
    alignRight: {},
    stickyTop: {},
    stickyLeft: {},
    stickyLeftBorder: {},
    stickyLeftScreen: {},
    verticalAlign: {},
    cellGroup: {
      [`.${e.headless} tr:first-child > &`]: {
        paddingTop: 0
      }
    },
    cellGroupSticky: {
      position: "sticky",
      top: m !== void 0 ? m : "var(--fab-table-sticky-group-header-top)",
      zIndex: 110,
      left: u !== void 0 ? 0 : void 0
    },
    noBottomBorder: {},
    stickyRight: {},
    mutedSubCell: {
      opacity: 0.8
    },
    cellActions: {
      alignItems: "center",
      display: "flex",
      height: "14px",
      justifyContent: "flex-end",
      position: "relative",
      top: "4px"
    },
    cellMask: {
      transition: "opacity 0.15s ease-in-out",
      "&:not(:focus-within)": {
        opacity: 0
      }
    },
    group: {
      fontSize: s.small.fontSize,
      lineHeight: s.small.lineHeight,
      alignItems: "center",
      backgroundColor: t.gray[100],
      borderRadius: r[200],
      color: t.gray[700],
      display: "flex",
      padding: l(0.75, 2)
    },
    groupIcon: {
      alignItems: "center",
      display: "inline-flex",
      fill: t.grey[600],
      height: 0,
      justifyContent: "center",
      marginRight: l(1)
    },
    groupContent: {
      flex: 1
    },
    tableExpandIcon: {
      alignItems: "center",
      display: "flex",
      fill: t.grey[800],
      "& > svg": {
        width: 10
        // <IconV2 size={10}> looks too small, so we do size={16} and constrain the width here instead
      }
    },
    tableExpandIconExpanded: {
      transform: "rotate(90deg)"
    }
  }, f = {
    root: {
      "--fab-table-sticky-group-header-top": "44px",
      boxSizing: "border-box",
      width: "100%",
      borderSpacing: 0,
      lineHeight: "normal",
      gridArea: "table",
      [`&.${e.fixedLayout}`]: {
        tableLayout: "fixed"
      },
      [`& > *:not(&.${e.tbodyForLoader})`]: {
        transition: "opacity 0.15s ease-in-out"
      },
      [`&.${e.tableLoading}`]: {
        position: "relative",
        [`& > *:not(&.${e.tbodyForLoader})`]: {
          opacity: 0.4
        }
      },
      [`&.${e.tableWithRowHover} .${e.row}:hover, &.${e.tableWithRowHover} .${e.row}:focus-within, &.${e.tableWithRowHover} .${e.row}:has([aria-expanded="true"])`]: {
        backgroundColor: t.gray[100]
      },
      [`&.${e.tableWithZebraStripes} .${e.row}:nth-child(even):not(.${e.rowSelected})`]: {
        backgroundColor: `rgba(${o.hexToRgb(t.gray[100])}, 0.5)`
      }
    },
    fixedLayout: {},
    tbodyForLoader: {},
    tableLoading: {},
    tableWithRowHover: {},
    tableWithZebraStripes: {},
    caption: {
      fontSize: 0,
      height: 0,
      overflow: "hidden"
    },
    wrap: {
      display: "grid",
      outline: d === V.Dye ? `1px solid ${N.main}` : void 0,
      "&:focus": {
        boxShadow: `0 0 0 2px ${o.alpha(t.primary.lighter, 0.35)}`
      }
    },
    wrapOverflow: {
      overflow: "auto"
    },
    innerWrap: {
      display: "grid",
      gridTemplateColumns: "0 auto 0",
      gridTemplateRows: "auto",
      // Yes... the " inside ' is necessary...
      gridTemplateAreas: '"left-scroll-screen table right-scroll-screen"'
    },
    stickyIndicators: {
      position: "sticky",
      display: "flex",
      justifyContent: "space-between",
      top: 0,
      height: 0,
      opacity: 0,
      pointerEvents: "none"
      // Enable z-index when deving on intersection observer. Also comment out opacity property
      // zIndex: 1000,
    },
    stickyIndicator: {
      top: 0,
      width: "10px",
      height: "10px",
      backgroundColor: "red",
      position: "sticky"
    },
    loaderCell: {
      padding: 0
    },
    loader: {
      position: "absolute",
      top: "44px",
      right: 0,
      left: 0,
      bottom: 0,
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    },
    leftScrollIndicator: {
      gridArea: "left-scroll-screen",
      alignSelf: "stretch",
      position: "sticky",
      left: 0,
      pointerEvents: "none",
      zIndex: 200,
      "&:before": {
        // borderLeft: `2px solid ${ palette.gray[400] }`,
        content: '""',
        height: "100%",
        position: "absolute",
        top: 0,
        bottom: 0,
        width: "48px"
      }
    },
    leftScrollIndicatorWithScreen: {
      "&:before": {
        background: `linear-gradient(90deg, ${t.common.white} 0%, transparent 100%)`
      }
    },
    rightScrollIndicator: {
      gridArea: "right-scroll-screen",
      alignSelf: "stretch",
      position: "sticky",
      right: 0,
      pointerEvents: "none",
      zIndex: 200,
      "&:before": {
        // borderRight: `2px solid ${ palette.gray[400] }`,
        content: '""',
        height: "100%",
        position: "absolute",
        top: 0,
        right: 0,
        bottom: 0,
        width: "48px"
      }
    },
    rightScrollIndicatorWithScreen: {
      "&:before": {
        background: `linear-gradient(270deg, ${t.common.white} 0%, transparent 100%)`
      }
    },
    row: {
      transition: "background-color 0.15s ease-in-out",
      outline: d === V.Dye ? `1px solid ${N.main}` : void 0,
      '&:has([aria-expanded="true"])': {
        [`.${e.cellMask}`]: {
          opacity: 1
        }
      },
      [`&:hover .${e.cellMask}`]: {
        opacity: 1
      },
      // START FF Fix
      // The following two rules have to be split up because otherwise FF chokes on the :has and ruins the entire selector (including the selector before the comma)
      // if you make changes to one, you have to make changes to the other
      [`&:hover .${e.stickyRight}`]: {
        position: "sticky",
        right: 0,
        zIndex: 100,
        "&:before": {
          background: `linear-gradient(90deg, transparent 0, ${t.common.white} 40px)`,
          content: '""',
          position: "absolute",
          width: "calc(100% + 40px)",
          top: 0,
          bottom: 0,
          right: 0
        }
      },
      [`&:has([aria-expanded="true"]) .${e.stickyRight}`]: {
        position: "sticky",
        right: 0,
        zIndex: 100,
        "&:before": {
          background: `linear-gradient(90deg, transparent 0, ${t.common.white} 40px)`,
          content: '""',
          position: "absolute",
          width: "calc(100% + 40px)",
          top: 0,
          bottom: 0,
          right: 0
        }
      },
      // End FF Fix
      [`&.${e.rowEmphasized}`]: {
        fontWeight: s.fontWeightSemibold
      },
      [`&.${e.rowHighlighted}, &.${e.rowSelected}`]: {
        backgroundColor: `rgba(${o.hexToRgb(t.primary.lightest)}, 0.1)`,
        [`& > .${e.stickyLeft}`]: {
          // the highlight/selected color is expecting to be overlaid on top of a solid white background
          // if we replace the solid white from sticky columns, we see the content underneath when it scrolls horizontally
          // So in order to keep the `palette.primary.lightest` with the `0.1` opacity we do this linear gradient trick
          // to layer the highlighted/selected color on top of white.
          // We cannot use pseudo before or after elements because they are already used for borders and shadows.
          background: `linear-gradient(rgba(${o.hexToRgb(t.primary.lightest)}, 0.1), rgba(${o.hexToRgb(
            t.primary.lightest
          )}, 0.1)), linear-gradient(${t.common.white}, ${t.common.white})`
        }
      },
      [`&.${e.rowCollapsible} td:first-child`]: {
        paddingLeft: "30px"
      }
    },
    removeBottomBorder: {},
    rowEmphasized: {},
    rowHighlighted: {},
    rowSelected: {},
    rowCollapsible: {},
    header: {
      boxSizing: "border-box",
      fontSize: (w = s.fabricFontSize) == null ? void 0 : w.call(s, "medium"),
      position: "relative",
      textAlign: "left",
      verticalAlign: "top",
      backgroundColor: d === V.Dye ? N.lighter : t.grey[200],
      color: t.grey[800],
      fontWeight: s.fontWeightBold,
      padding: "12px 16px 11px",
      transition: "background-color 0.15s ease-in-out",
      borderColor: "transparent",
      "&:first-of-type": {
        borderRadius: "2px 0 0 2px"
      },
      "&:last-of-type": {
        borderRadius: "0 2px 2px 0"
      },
      [`&.${e.minimalRightPadding}`]: {
        paddingRight: "4px"
      },
      [`&.${e.noVerticalPadding}`]: {
        paddingTop: 0,
        paddingBottom: 0
      },
      [`&.${e.noHorizontalPadding}`]: {
        paddingLeft: 0,
        paddingRight: 0
      },
      [`&.${e.alignCenter}`]: {
        textAlign: "center"
      },
      [`&.${e.alignRight}`]: {
        textAlign: "right"
      },
      [`.${e.headless} &`]: {
        borderBottom: `1px solid ${t.grey[300]}`,
        fontSize: 0,
        height: 0,
        lineHeight: 0,
        paddingTop: 0,
        paddingBottom: 0,
        pointerEvents: "none"
      },
      [`&.${e.noBottomBorderRadius}`]: {
        "&:first-of-type": {
          borderBottomLeftRadius: 0
        },
        "&:last-of-type": {
          borderBottomRightRadius: 0
        }
      },
      [`&.${e.stickyTop}`]: {
        position: "sticky",
        top: 0,
        zIndex: 120
      },
      [`&.${e.stickyLeft}`]: {
        position: "sticky",
        left: 0,
        zIndex: 130
      },
      [`&.${e.stickyLeftBorder}:before`]: {
        backgroundColor: t.gray[400],
        content: '""',
        position: "absolute",
        top: 0,
        right: 0,
        bottom: "-1px",
        width: "2px"
      },
      [`&.${e.stickyLeftScreen}:after`]: {
        background: `linear-gradient(90deg, ${t.common.white} 0%, transparent 100%)`,
        boxSizing: "border-box",
        content: '""',
        position: "absolute",
        top: 0,
        right: "-46px",
        width: "46px",
        pointerEvents: "none",
        opacity: 1,
        bottom: 0
      },
      [`&.${e.sortableHeader}`]: {
        "&:hover": {
          cursor: "pointer"
        },
        [`&:not(&.${e.whiteHeaderVariant}):hover`]: {
          backgroundColor: t.gray[300],
          "&:not(:first-of-type):before, &:not(:last-of-type):after": {
            "&::after": {
              borderRadius: "inherit",
              bottom: "2px",
              boxShadow: `0px 0px 0px 2px ${o.alpha(i.surface.primary.medium, 0.8)}`,
              content: '""',
              left: "2px",
              overflow: "visible",
              position: "absolute",
              right: "2px",
              top: "2px",
              width: "unset"
            }
          }
        }
      },
      [`&.${e.whiteHeaderVariant}`]: {
        borderBottom: `1px solid ${t.grey[300]}`,
        backgroundColor: t.common.white
      }
    },
    headless: {
      [`.${e.root}&`]: {
        "--fab-table-sticky-group-header-top": "0px"
      }
    },
    whiteHeaderVariant: {},
    noBottomBorderRadius: {},
    sortableHeader: {
      [`&:has(.${e.sortIcon}:focus-visible)`]: {
        // This is the styles for when a sortable header cell is tabbed to
        "&::after": {
          borderRadius: "inherit",
          bottom: "2px",
          boxShadow: `0px 0px 0px 2px ${o.alpha(i.surface.primary.medium, 0.8)}`,
          content: '""',
          left: "2px",
          overflow: "visible",
          position: "absolute",
          right: "2px",
          top: "2px"
        }
      }
    },
    sortIcon: {
      // Styles the sort button and makes it cover the whole th element
      backgroundColor: "transparent",
      border: "0px solid transparent",
      borderRadius: "inherit",
      padding: "0px",
      "&:hover": {
        cursor: "pointer"
      }
    },
    hideSortIcon: {
      opacity: 0
    },
    sortableHeaderCell: {
      alignItems: "center",
      display: "flex",
      gap: l(1),
      [`&:has(.${e.sortIcon}:focus-visible) .${e.hideSortIcon}`]: {
        opacity: 1
      }
    },
    sortIconAscending: {},
    cell: {
      boxSizing: "border-box",
      fontSize: (g = s.fabricFontSize) == null ? void 0 : g.call(s, "medium"),
      position: "relative",
      textAlign: "left",
      verticalAlign: "top",
      color: t.grey[1e3],
      borderBottom: `1px solid ${t.grey[300]}`,
      padding: "13px 16px 15px",
      [`&.${e.minimalRightPadding}`]: {
        paddingRight: "4px"
      },
      [`&.${e.noVerticalPadding}`]: {
        paddingTop: 0,
        paddingBottom: 0
      },
      [`&.${e.noHorizontalPadding}`]: {
        paddingLeft: 0,
        paddingRight: 0
      },
      [`&.${e.alignCenter}`]: {
        textAlign: "center"
      },
      [`&.${e.alignRight}`]: {
        textAlign: "right"
      },
      [`&.${e.verticalAlign}`]: {
        verticalAlign: "middle"
      },
      [`&.${e.stickyLeft}`]: {
        position: "sticky",
        left: 0,
        background: t.common.white,
        backgroundClip: "padding-box",
        transition: "background 0.15s ease-in-out",
        // animation for background when selected/highlighted
        zIndex: 90
      },
      [`&.${e.stickyLeftBorder}:before`]: {
        backgroundColor: t.gray[400],
        content: '""',
        position: "absolute",
        top: 0,
        right: 0,
        bottom: "-1px",
        width: "2px"
      },
      [`&.${e.stickyLeftScreen}:after`]: {
        background: `linear-gradient(90deg, ${t.common.white} 0%, transparent 100%)`,
        boxSizing: "border-box",
        content: '""',
        position: "absolute",
        top: 0,
        right: "-46px",
        width: "46px",
        pointerEvents: "none",
        opacity: 1,
        bottom: 0
      },
      [`&.${e.cellGroup}`]: {
        backgroundColor: d === V.Dye ? N.lightest : t.grey[100],
        borderTop: `1px solid ${t.gray[300]}`,
        color: t.grey[800],
        fontSize: (S = s.fabricFontSize) == null ? void 0 : S.call(s, "small"),
        fontWeight: s.fontWeightBold,
        [`&:not(&.${e.noVerticalPadding})`]: {
          paddingTop: "9px",
          paddingBottom: "9px"
        }
      },
      [`&.${e.noBottomBorder}`]: {
        borderBottom: "none"
      },
      [`&.${e.triangleIcon}`]: {
        paddingLeft: "5px"
      },
      [`&.${e.triangleIcon} svg`]: {
        marginRight: "7px"
      }
    },
    triangleIcon: {},
    minimalRightPadding: {},
    noVerticalPadding: {},
    noHorizontalPadding: {},
    alignCenter: {},
    alignRight: {},
    stickyTop: {},
    stickyLeft: {},
    stickyLeftBorder: {},
    stickyLeftScreen: {},
    verticalAlign: {},
    cellGroup: {},
    cellGroupSticky: {
      position: "sticky",
      top: m !== void 0 ? m : "var(--fab-table-sticky-group-header-top)",
      zIndex: 110,
      left: u !== void 0 ? 0 : void 0
    },
    noBottomBorder: {},
    stickyRight: {},
    mutedSubCell: {
      opacity: 0.6
    },
    cellActions: {
      alignItems: "center",
      display: "flex",
      height: "14px",
      justifyContent: "flex-end",
      position: "relative",
      top: "4px"
    },
    cellMask: {
      transition: "opacity 0.15s ease-in-out",
      "&:not(:focus-within)": {
        opacity: 0
      }
    },
    group: {
      display: "flex",
      alignItems: "center"
    },
    groupIcon: {
      alignItems: "center",
      display: "inline-flex",
      fill: t.grey[600],
      height: 0,
      justifyContent: "center",
      marginRight: "7px"
    },
    groupContent: {
      flex: 1
    },
    tableExpandIcon: {
      fill: t.grey[800],
      transition: "300ms"
    },
    tableExpandIconExpanded: {
      transform: "rotate(90deg)"
    }
  };
  return P.ifFeature("encore", c, f);
};
let ye = !1;
const M = Be.createLogger("<Table>");
function Ne() {
  const y = class y extends Le {
    constructor(r) {
      super(r), this._isCollapsibleTableRow = (n) => typeof n == "object" && n !== null ? "collapsibleRows" in n : !1, this._handleCollapsibleRowKeyPress = (n, p) => {
        const { rowKey: c = y.defaultProps.rowKey, rowSelectedBlacklist: f = [] } = this.props, w = this.rowSelectionSelectorBlacklist.concat(f).join(",");
        if (p.target && p.target.closest(w))
          return;
        const S = (this._uiRows || []).map(c).findIndex((h) => h === n);
        this._handleSelectingRow(S, p.shiftKey), this._lastClickedRow = S;
      }, this._handleRowClick = (n) => {
        const { rowKey: p = y.defaultProps.rowKey, rowSelectedBlacklist: c = [] } = this.props;
        return (f) => {
          const w = window.getSelection();
          if (f.shiftKey) {
            const b = window.getSelection();
            b && b.removeAllRanges();
          }
          if (w && w.toString().trim() !== "")
            return;
          const g = this.rowSelectionSelectorBlacklist.concat(c).join(",");
          if (f.target && f.target.closest(g))
            return;
          const h = (this._uiRows || []).map(p).findIndex((b) => b === n);
          this._handleSelectingRow(h, f.shiftKey), this._lastClickedRow = h;
        };
      }, this._handleSelectingAllRows = () => {
        const { onRowSelection: n, onRowSelect: p, rows: c, rowKey: f = y.defaultProps.rowKey } = this.props;
        if (!p && !n)
          return;
        const w = this._makeGetRowSelection(), g = this._makeCheckRowSelectionIsDisabled(), S = c.filter(le(g));
        if (p) {
          const h = S.filter(le(w)), b = !!h.length, C = b ? h : S.filter(w);
          p(C.map(f), b);
        } else {
          const h = S.some(le(w));
          let b = /* @__PURE__ */ new Set();
          h && (b = new Set(S.map(f))), typeof n == "function" && n(b);
        }
      }, this._handleSelectingRow = (n, p) => {
        const { onRowSelection: c, onRowSelect: f, rowKey: w = y.defaultProps.rowKey, rows: g } = this.props, { collapsibleRowsState: S } = this.state, h = this._uiRows[n], b = w(h);
        if (h && this._isCollapsibleTableRow(h)) {
          const x = S == null ? void 0 : S.find((R) => R.tableRowKey === b);
          let L = [];
          x ? L = S == null ? void 0 : S.map((R) => R.tableRowKey === b ? {
            ...R,
            isExpanded: !R.isExpanded
          } : R) : L = [...S, { tableRowKey: b, isExpanded: !0 }], this.setState({
            collapsibleRowsState: L
          });
        }
        if (!c && !f)
          return;
        const C = this._makeGetRowSelection(), v = this._makeCheckRowSelectionIsDisabled(), _ = !C(h);
        if (f) {
          const x = [];
          if (p && this._lastClickedRow !== null) {
            const L = Math.min(this._lastClickedRow, n), R = Math.abs(this._lastClickedRow - n);
            for (let I = 0; I <= R; I++) {
              const H = this._uiRows[I + L];
              !v(H) && C(H) !== _ && x.push(H);
            }
          } else v(h) || x.push(h);
          if (!x.length)
            return;
          f(x.map(w), _);
        } else {
          const x = new Set(g.filter(C).map(w)), L = _ ? "add" : "delete";
          if (x[L](w(h)), p && this._lastClickedRow !== null) {
            const R = Math.min(this._lastClickedRow, n), I = Math.abs(this._lastClickedRow - n);
            for (let H = 0; H <= I; H++) {
              const T = this._uiRows[H + R];
              x[L](w(T));
            }
          }
          c && c(x);
        }
      }, this._handleSort = (n, p) => {
        const { columns: c, onSort: f } = this.props, { columnIndex: w, isAsc: g } = this._getSort(), S = c[n];
        let h = !0;
        n === w && g && (h = !1);
        let b = "", C = "";
        typeof p == "string" ? (b = window.jQuery ? $.__("Sorted table by %s in ascending order", p) : `Sorted table by ${p} in ascending order`, C = window.jQuery ? $.__("Sorted table by %s in descending order", p) : `Sorted table by ${p} in descending order`) : (b = window.jQuery ? $.__("Sorted table by column %d in ascending order", p) : `Sorted table by column ${p} in ascending order`, C = window.jQuery ? $.__("Sorted table by column %d in descending order", p) : `Sorted table by column ${p} in descending order`);
        const v = h ? b : C;
        v !== this.state.sortMessage && this.setState({
          sortMessage: v
        }), this._lastClickedRow = null, this.setState({
          columnIndex: n,
          isAsc: h
        }), f && typeof S.sortBy < "u" && f(n, S.sortBy, h);
      }, this._setupIntersectionObserver = () => {
        if (!window.IntersectionObserver)
          return;
        const { horizontalScrollContainer: n } = this.props, p = {
          root: n === void 0 ? this.tableWrapRef.current : n,
          rootMargin: "0px",
          // Why isn't this 1? Well because FireFox is 💩 and triggers on the right side between (0.95 and 1)
          threshold: 0.95
        };
        this.intersectionObserver = new IntersectionObserver((c) => {
          c.forEach((f) => {
            const w = f.isIntersecting && f.intersectionRatio >= 0.95;
            f.target === this.leftScrollIndicatorRef.current && this.setState({
              isScrolledLeftHorizontally: !w
            }), f.target === this.rightScrollIndicatorRef.current && this.setState({
              isScrolledRightHorizontally: !w
            });
          });
        }, p), this.leftScrollIndicatorRef && this.leftScrollIndicatorRef.current && this.intersectionObserver.observe(this.leftScrollIndicatorRef.current), this.rightScrollIndicatorRef && this.rightScrollIndicatorRef.current && this.intersectionObserver.observe(this.rightScrollIndicatorRef.current);
      }, this._destroyIntersectionObserver = () => {
        this.intersectionObserver && (this.intersectionObserver.disconnect(), this.intersectionObserver = null);
      }, this._getLastColumnCellType = (n) => {
        const p = n && n[n.length - 1], c = typeof p == "object" ? p.cell : void 0;
        return typeof c == "object" ? c.type : void 0;
      };
      const { initialSort: i, onSort: o, preSorted: t, rows: l, rowSelectedBy: s, onRowSelection: d, stickyColumn: u } = r;
      s && M.warn(
        "Table prop `rowSelectedBy` is deprecated in favor of using the `selected` property in the cell.type: checkbox object."
      ), d && M.warn(
        "Table prop `onRowSelection` is deprecated in favor of `onRowSelect`. See the docs for more information."
      ), u && M.warn(
        "Table prop `stickyColumn` is deprecated in favor of specifying the total number of columns you want stickied with the `stickyColumns` property."
      ), this._uiRows = l, this._lastClickedRow = null, this.rowSelectionSelectorBlacklist = [
        "a",
        "button",
        "select",
        '[data-fabric-component="Select"]',
        "textarea",
        'input:not([id^="fabricTableCheckboxCell"])',
        ".fab-Checkbox"
      ];
      const m = o ? t : i;
      this.state = {
        columnIndex: null,
        isAsc: !0,
        isScrolledLeftHorizontally: !1,
        isScrolledRightHorizontally: !1,
        collapsibleRowsState: [],
        stickyColumnLeftOffsets: [],
        sortMessage: "",
        ...m
      }, this.intersectionObserver = null, this.tableWrapRef = re(), this.leftScrollIndicatorRef = re(), this.rightScrollIndicatorRef = re(), this.uuid = r.uuid ? r.uuid : O.uniqueId(), this.collapsibleRowButtonRef = re();
    }
    static set tooltipAdapter(r) {
      !ye && typeof r == "object" && O.has(r, "show") ? ye = !0 : M.warn('A tooltip adapter must be an object with a property called "show" that is a function.');
    }
    /* eslint-disable-next-line class-methods-use-this */
    _createDefinedCellFunction(r, i) {
      switch (r.type) {
        case "checkbox": {
          const { biId: o, rowIsSelected: t, rowSelectionIsDisabled: l, rowKey: s } = i;
          return (d) => Ke({ biId: o, rowIsSelected: t, rowKey: s, rowSelectionIsDisabled: l });
        }
        case "actions": {
          const { actions: o } = r, { classes: t } = i;
          return (l) => Oe({ actions: o, classes: t, row: l });
        }
        default:
          return M.warn(`Unknown cell type "${r.type}" was used. Empty <td> was rendered.`), () => {
          };
      }
    }
    removeSortState() {
      this.setState({
        columnIndex: null,
        isAsc: !0
      });
    }
    _getCheckboxTypeCell() {
      const { columns: r } = this.props, i = r.find((o) => typeof o.cell == "object" && o.cell.type === "checkbox");
      return i ? i.cell : void 0;
    }
    /**
     * Gets the number of columns that should be stickied. If `stickyColumns` isn't provided but the deprecated prop `stickyColumn` is, then return 1.
     * @returns the number of columns to be stickied.
     */
    _getStickyColumns() {
      const { stickyColumns: r, stickyColumn: i } = this.props;
      return !r && i ? 1 : r ?? 0;
    }
    /**
     * Gets what classes and inline styles to apply to a cell if sticky columns are enabled.
     * @param index The index of the column
     * @returns An object containing what `classes` to apply and any inline styles to use.
     */
    _getStickyColumnStyles(r) {
      const { isScrolledLeftHorizontally: i, isScrolledRightHorizontally: o, stickyColumnLeftOffsets: t } = this.state, l = this._getStickyColumns(), s = l > r, d = l - 1 === r;
      return {
        classes: {
          stickyLeft: s && (i || o),
          stickyLeftBorder: d && (i || o),
          stickyLeftScreen: d && i
        },
        inlineStyles: {
          left: s && (i || o) ? t[r] ?? 0 : void 0
        }
      };
    }
    /**
     * If `stickyColumns` is set to 2 or more, we need to set the `left` css property on our sticky columns to the previous cells width.
     * This function looks for the first row that contains all of our cells so we can calculate the left offset for each sticky column.
     *
     * This does not reset state if our left offsets didn't change.
     */
    _resyncStickyColumnWidths() {
      var u;
      const { stickyColumnLeftOffsets: r } = this.state, i = this._getStickyColumns();
      if (i <= 1) return;
      const o = (u = this.tableWrapRef.current) == null ? void 0 : u.querySelector("table");
      if (!o) return;
      const t = Array.from(o.rows).find((m) => {
        for (let n = 0; n < m.cells.length && n < i; n++)
          if (m.cells[n].colSpan > 1)
            return !1;
        return !0;
      });
      if (!t) return;
      const l = Array.from(t.cells, (m) => m.offsetWidth), s = [];
      let d = 0;
      for (let m = 0; m < l.length && m < i; m++)
        s.push(d), d += l[m];
      if (r.length === s.length) {
        let m = !0;
        for (let n = 0; n < r.length; n++)
          if (r[n] !== s[n]) {
            m = !1;
            break;
          }
        if (m) return;
      }
      this.setState({
        stickyColumnLeftOffsets: s
      });
    }
    _getSorter(r) {
      const { isAsc: i } = this.state, { sort: o, sortBy: t } = r;
      if (typeof o == "function")
        return (l) => [...l].sort(i ? o : (s, d) => o(d, s));
      if (typeof t == "function")
        return (l) => Pe(l, t, i);
      throw new Error(`Table column object ${JSON.stringify(r)} is missing a required \`sort\` or \`sortBy\` function.`);
    }
    _makeGetRowSelection() {
      const { rowSelectedBy: r = (t) => !!t.selected } = this.props;
      let i = r;
      const o = this._getCheckboxTypeCell();
      return o && o.selected && (i = o.selected), i;
    }
    _makeCheckRowSelectionIsDisabled() {
      let r = () => !1;
      const i = this._getCheckboxTypeCell();
      return i && i.disabled && (r = i.disabled), r;
    }
    _renderDefinedHeaderType(r, i) {
      const { biId: o, classes: t, rows: l, headerVariant: s, stickyHeader: d, stickyHeaderTop: u } = this.props, { uuid: m } = this, n = Y.getClasses(this.props), p = this._makeGetRowSelection(), c = this._makeCheckRowSelectionIsDisabled(), f = this._getStickyColumnStyles(i);
      switch (r) {
        case "checkbox": {
          const w = l.filter(c).length === l.length;
          return Fe({
            biId: o,
            checked: !!(l.length && !w && l.filter(le(c)).every(p)),
            classes: n,
            headerVariant: s,
            left: f.inlineStyles.left,
            onToggleAll: this._handleSelectingAllRows,
            stickyHeader: d,
            stickyHeaderTop: u,
            stickyLeft: f.classes.stickyLeft,
            stickyLeftBorder: f.classes.stickyLeftBorder,
            stickyLeftScreen: f.classes.stickyLeftScreen,
            uuid: m
          });
        }
        default:
          return null;
      }
    }
    _getSort() {
      const { manualSort: r } = this.props;
      if (r)
        return r;
      const { columnIndex: i, isAsc: o } = this.state;
      return {
        columnIndex: i,
        isAsc: o
      };
    }
    _renderTableHeaderRow(r) {
      const { columns: i, stickyHeader: o, stickyHeaderTop: t, headerVariant: l } = this.props, { columnIndex: s, isAsc: d } = this._getSort(), u = s !== null, m = me(i), n = Y.getClasses(this.props);
      return /* @__PURE__ */ a.jsx("tr", { children: (() => {
        const p = [];
        for (let c = 0; c < i.length; c++) {
          const { align: f, headerPaddingReset: w, cell: g, key: S, sort: h, sortBy: b, width: C, headerColSpan: v } = i[c], _ = !!(h || b), { header: x, headerAriaLabel: L } = i[c];
          if (typeof x == "object" && !ue(x) && x.type)
            p.push(this._renderDefinedHeaderType(x.type, c));
          else {
            const R = this._getStickyColumnStyles(c);
            v && v > 1 && (c += v - 1), !x && !L && M.warn(
              "When a column does not have a header, it should use the headerAriaLabel property to describe the content of the table for accessibility purposes."
            );
            const I = c + 1, H = typeof x == "string" ? x : I, T = d ? "arrow-up-regular" : "arrow-down-regular", Q = () => typeof x == "string" ? window.jQuery ? $.__("Sort table by %s", x) : `Sort table by ${x}` : window.jQuery ? $.__("Sort table by column %d", I) : `Sort table by column ${I}`, B = S || g && g.toString(), U = u && s === c, Z = A(n.header, {
              [n.sortableHeader]: !m && _,
              [n.alignCenter]: f === "center",
              [n.alignRight]: f === "right",
              [n.noVerticalPadding]: w === "all" || w === "vertical",
              [n.noHorizontalPadding]: w === "all" || w === "horizontal",
              [n.stickyTop]: o,
              [n.stickyLeft]: R.classes.stickyLeft,
              [n.stickyLeftBorder]: R.classes.stickyLeftBorder,
              [n.stickyLeftScreen]: R.classes.stickyLeftScreen,
              // @startCleanup encore
              [n.noBottomBorderRadius]: P.ifFeature("encore", !1, r),
              // @endCleanup encore
              [n.whiteHeaderVariant]: l === "white"
            }), D = {
              left: R.inlineStyles.left,
              minWidth: C,
              top: t || void 0,
              width: C
            };
            p.push(
              /* @__PURE__ */ a.jsx(
                "th",
                {
                  "aria-label": x ? void 0 : L,
                  className: Z,
                  colSpan: v && v > 1 ? v : void 0,
                  onClick: (j) => {
                    const q = j.target.closest(`button:not(#fabric-table-sort-button-${c})`);
                    _ && !q && this._handleSort(c, H);
                  },
                  scope: "col",
                  style: D,
                  children: !x && L ? /* @__PURE__ */ a.jsx(se, { children: L }) : _ ? /* @__PURE__ */ a.jsxs("span", { className: n.sortableHeaderCell, children: [
                    x,
                    /* @__PURE__ */ a.jsx(
                      "button",
                      {
                        "aria-label": Q(),
                        className: n.sortIcon,
                        id: `fabric-table-sort-button-${c}`,
                        onClick: () => this._handleSort(c, H),
                        type: "button",
                        children: U ? /* @__PURE__ */ a.jsx(ne, { color: "neutral-strong", name: T, size: 12 }) : /* @__PURE__ */ a.jsx("span", { className: n.hideSortIcon, children: /* @__PURE__ */ a.jsx(
                          ne,
                          {
                            color: "neutral-strong",
                            name: "arrow-up-arrow-down-regular",
                            size: 12
                          }
                        ) })
                      }
                    )
                  ] }) : x
                },
                B
              )
            );
          }
        }
        return p;
      })() });
    }
    _renderRows(r = [], i = !1, o = !1) {
      const { collapsibleRowsState: t } = this.state, { rowKey: l = y.defaultProps.rowKey } = this.props;
      return r.map((s, d) => {
        var n;
        const u = l(s), m = this._renderRow(r, i, s, d, o);
        if (this._isCollapsibleTableRow(s) && ((n = t == null ? void 0 : t.find((c) => c.tableRowKey === u)) == null ? void 0 : n.isExpanded)) {
          const c = s, f = this._renderRows(
            c.collapsibleRows,
            i,
            !0
          );
          return [m, ...f];
        }
        return m;
      });
    }
    _renderRow(r = [], i = !1, o, t, l = !1) {
      const {
        biId: s,
        columns: d,
        rowKey: u = y.defaultProps.rowKey,
        rowEmphasizedBy: m,
        rowHighlightedBy: n,
        rowMutedBy: p,
        onRowMouseEnter: c,
        onRowMouseLeave: f,
        removeBottomBorder: w = !1
      } = this.props, g = Y.getClasses(this.props), { isScrolledRightHorizontally: S, collapsibleRowsState: h } = this.state, b = this._makeGetRowSelection(), C = this._makeCheckRowSelectionIsDisabled(), v = b(o), _ = C(o), x = u(o), L = typeof p == "function" ? p(o) : !1, R = t === r.length - 1, I = this._isCollapsibleTableRow(o), H = A(g.row, {
        [g.removeBottomBorder]: w && R || R && i,
        [g.rowEmphasized]: m ? m(o) : !1,
        [g.rowHighlighted]: n ? n(o) : !1,
        [g.rowSelected]: v && !_,
        [g.rowCollapsible]: l
      });
      return /* @__PURE__ */ a.jsx(
        "tr",
        {
          className: H,
          onClick: this._handleRowClick(x),
          onMouseEnter: O.isFunction(c) ? (T) => {
            c(T.currentTarget, o);
          } : void 0,
          onMouseLeave: O.isFunction(f) ? (T) => {
            f(T.currentTarget, o);
          } : void 0,
          children: (() => {
            var Q;
            const T = [];
            for (let B = 0; B < d.length; B++) {
              const { align: U, header: Z, mute: D, cell: j, cellPaddingReset: G, colSpan: q, verticalAlign: z, width: W } = d[B];
              let { showOnHover: K, keepInView: E = null } = d[B];
              const ce = B === 0, Se = B === d.length - 1;
              let F = 1;
              typeof q == "function" && (F = q(o), F === !0 ? F = d.length - B : typeof F != "number" && (F = 1), F > 1 && (B += F - 1)), K = O.isFunction(K) ? K(o) : K;
              let ee = "", de = j;
              typeof j == "object" && !ue(j) && j.type && (ee = j.type, de = this._createDefinedCellFunction(j, {
                biId: s,
                classes: g,
                rowIsSelected: v,
                rowKey: x,
                rowSelectionIsDisabled: _
              }));
              const pe = typeof j == "string" ? j : de(o, t, r);
              let { key: X } = d[B];
              X || (typeof Z == "string" ? X = Z : typeof j == "string" ? X = j : X = `${this.uuid}-${B}`);
              let te = L;
              ee === "checkbox" && !v && _ ? te = !1 : typeof D == "boolean" ? te = D : O.isFunction(D) && (te = D(o));
              const he = te ? /* @__PURE__ */ a.jsx("div", { className: g.mutedSubCell, children: pe }) : pe, ge = K ? /* @__PURE__ */ a.jsx("div", { className: g.cellMask, children: he }) : he;
              O.isFunction(E) ? E = !!E(o) : E !== null && (E = !!E);
              const ke = Se && E !== !1 && S && (ee === "actions" || E === !0), oe = this._getStickyColumnStyles(B), Re = A(g.cell, {
                [g.stickyRight]: ke,
                [g.alignCenter]: U === "center",
                [g.alignRight]: U === "right",
                [g.verticalAlign]: z,
                [g.minimalRightPadding]: ee === "checkbox",
                [g.noVerticalPadding]: G === "all" || G === "vertical",
                [g.noHorizontalPadding]: G === "all" || G === "horizontal",
                [g.stickyLeft]: oe.classes.stickyLeft,
                [g.stickyLeftBorder]: oe.classes.stickyLeftBorder,
                [g.stickyLeftScreen]: oe.classes.stickyLeftScreen,
                [g.noBottomBorder]: R && i,
                // @startCleanup encore
                [g.triangleIcon]: P.ifFeature("encore", void 0, I && ce)
                // @endCleanup encore
              }), ie = (Q = h == null ? void 0 : h.find((J) => J.tableRowKey === x)) == null ? void 0 : Q.isExpanded, Ce = window.jQuery ? $.__("Collapse row") : "Collapse row", $e = window.jQuery ? $.__("Expand row") : "Expand row", ve = {
                left: oe.inlineStyles.left
              };
              T.push(
                /* @__PURE__ */ a.jsx(
                  "td",
                  {
                    className: Re,
                    colSpan: F > 1 ? F : void 0,
                    style: ve,
                    width: W,
                    children: I && ce ? /* @__PURE__ */ a.jsxs(
                      je,
                      {
                        alignItems: "center",
                        "aria-expanded": !!ie,
                        "aria-label": ie ? Ce : $e,
                        gap: P.ifFeature("encore", 1),
                        onKeyPress: (J) => {
                          (J.code === "Enter" || J.code === "Space") && (J.preventDefault(), this._handleCollapsibleRowKeyPress(x, J));
                        },
                        ref: this.collapsibleRowButtonRef,
                        role: "button",
                        tabIndex: 0,
                        children: [
                          P.ifFeature(
                            "encore",
                            /* @__PURE__ */ a.jsx(
                              "div",
                              {
                                className: A(g.tableExpandIcon, {
                                  [g.tableExpandIconExpanded]: ie
                                }),
                                children: /* @__PURE__ */ a.jsx(ne, { name: "caret-right-solid", size: 16 })
                              }
                            ),
                            /* @__PURE__ */ a.jsx(
                              xe,
                              {
                                className: A(g.tableExpandIcon, {
                                  [g.tableExpandIconExpanded]: ie
                                })
                              }
                            )
                          ),
                          ge
                        ]
                      }
                    ) : ge
                  },
                  X
                )
              );
            }
            return T;
          })()
        },
        x
      );
    }
    _renderGroupHeader({ id: r, title: i, icon: o, content: t, paddingReset: l }) {
      const { columns: s, stickyGroupHeaders: d } = this.props, u = Y.getClasses(this.props), m = o ? /* @__PURE__ */ a.jsx("div", { className: u.groupIcon, children: typeof o == "string" ? P.ifFeature("encore", /* @__PURE__ */ a.jsx(ne, { name: o, size: 12 }), /* @__PURE__ */ a.jsx(_e, { name: o })) : o }) : null, n = A([u.cell, u.cellGroup].join(" "), {
        [u.noVerticalPadding]: l === "all" || l === "vertical",
        [u.noHorizontalPadding]: l === "all" || l === "horizontal",
        [u.cellGroupSticky]: d
      }), p = A([u.cell, u.cellGroup].join(" "), {
        [u.cellGroupSticky]: d
      }), c = A(u.group, {
        [u.noVerticalPadding]: l === "all" || l === "vertical",
        [u.noHorizontalPadding]: l === "all" || l === "horizontal"
      }), f = this._getStickyColumns() > 0, w = f ? Math.ceil(s.length / 2) : s.length, g = s.length - w;
      return /* @__PURE__ */ a.jsxs("tr", { children: [
        /* @__PURE__ */ a.jsx("th", { className: P.ifFeature("encore", p, n), colSpan: w, children: /* @__PURE__ */ a.jsxs("div", { className: P.ifFeature("encore", c, u.group), children: [
          m,
          t && /* @__PURE__ */ a.jsx("div", { className: u.groupContent, children: t }),
          !t && i
        ] }) }),
        f && /* @__PURE__ */ a.jsx("th", { className: P.ifFeature("encore", p, n), colSpan: g })
      ] }, r);
    }
    /**
     * returns something like
     * [
     *     [GroupHeader, [GroupRow, GroupRow]],
     *     [GroupHeader, [GroupRow, GroupRow]]
     * ]
     */
    _renderVisibleGroups(r, i) {
      return r.filter((o) => {
        const { id: t, showIfEmpty: l } = o;
        return i && i[t] || l;
      }).map((o, t, l) => {
        const { id: s } = o, d = i && i[s], u = t !== l.length - 1 && !!l[t + 1];
        return [this._renderGroupHeader(o), this._renderRows(d || [], u)];
      });
    }
    componentDidMount() {
      this._setupIntersectionObserver();
    }
    componentDidUpdate(r, i) {
      var l, s, d;
      const { collapsibleRowsState: o } = i, { collapsibleRowsState: t } = this.state;
      !O.isEqual(t, o) && ((l = this.collapsibleRowButtonRef) != null && l.current) && ((d = (s = this.collapsibleRowButtonRef) == null ? void 0 : s.current) == null || d.focus()), this._resyncStickyColumnWidths();
    }
    componentWillUnmount() {
      this._destroyIntersectionObserver();
    }
    render() {
      const {
        biId: r,
        caption: i,
        columns: o,
        containerRef: t,
        id: l,
        isFixedLayout: s,
        isLoading: d,
        isZebra: u,
        note: m,
        onSort: n,
        rowKey: p,
        groups: c = [],
        groupBy: f = y.defaultProps.groupBy,
        maxHeight: w,
        maxWidth: g,
        horizontalScrollContainer: S
      } = this.props, h = Y.getClasses(this.props);
      let { rows: b, rowsHaveHoverEffect: C } = this.props;
      const { columnIndex: v, isScrolledLeftHorizontally: _, isScrolledRightHorizontally: x, sortMessage: L } = this.state, R = c && c.length > 0;
      let I = null;
      if (!n && v !== null && (b = this._getSorter(o[v])(b)), this._uiRows = b, R) {
        const z = c.map((W) => W.id);
        I = Ge(b, f), b = b.filter((W) => !z.includes(f(W))), Array.isArray(z) && z.length > 0 && (this._uiRows = z.reduce((W, K) => {
          if (K === "undefined")
            return W;
          let E = I && I[K] ? I[K] : [];
          return Array.isArray(E) || (E = []), [...W, ...E];
        }, b || []));
      }
      b == null || b.forEach((z) => {
        if (this._isCollapsibleTableRow(z)) {
          const W = z;
          this._uiRows = [...this._uiRows, ...W.collapsibleRows];
        }
      }), i || M.warn("Tables should have a caption. Please see the docs for more information."), !o && b && b.length && M.error("Rows cannot be rendered without first defining columns."), b && b.length && p === void 0 && M.error('Prop "rowKey" must be supplied when rendering rows.'), C !== void 0 && (C = !!C);
      const H = C === !1 ? !1 : [
        C === !0,
        o && o.some((z) => z.showOnHover),
        o && this._getLastColumnCellType(o) === "actions"
      ].some((z) => z), T = A(h.root, {
        [h.fixedLayout]: s,
        [h.headless]: me(o),
        [h.tableLoading]: d,
        [h.tableWithRowHover]: H,
        [h.tableWithZebraStripes]: u
      }), Q = A(h.wrap, {
        [h.wrapOverflow]: S === void 0
      }), B = {
        maxHeight: w,
        maxWidth: g
      }, U = R && b.length === 0, Z = A(h.leftScrollIndicator, {
        [h.leftScrollIndicatorWithScreen]: _
      }), D = A(h.rightScrollIndicator, {
        [h.rightScrollIndicatorWithScreen]: x
      }), j = this._renderVisibleGroups(c, I), G = {
        tabIndex: S === void 0 ? 0 : -1
      }, q = this._getStickyColumns() > 0;
      return /* @__PURE__ */ a.jsxs(
        "div",
        {
          className: Q,
          "data-fabric-component": "Table",
          id: l,
          ref: Ee(this.tableWrapRef, t),
          style: B,
          ...G,
          children: [
            /* @__PURE__ */ a.jsxs("div", { className: h.stickyIndicators, children: [
              /* @__PURE__ */ a.jsx("div", { className: h.stickyIndicator, ref: this.leftScrollIndicatorRef }),
              /* @__PURE__ */ a.jsx("div", { className: h.stickyIndicator, ref: this.rightScrollIndicatorRef })
            ] }),
            /* @__PURE__ */ a.jsxs("div", { className: h.innerWrap, children: [
              !q && (_ || x) && // grid: right-left-screen
              /* @__PURE__ */ a.jsx("div", { className: Z }),
              /* @__PURE__ */ a.jsxs("table", { className: T, "data-bi-id": r, children: [
                i && /* @__PURE__ */ a.jsx("caption", { className: h.caption, children: i }),
                o && /* @__PURE__ */ a.jsx("thead", { children: this._renderTableHeaderRow(U) }),
                m && /* @__PURE__ */ a.jsx("tbody", { children: /* @__PURE__ */ a.jsx("tr", { children: /* @__PURE__ */ a.jsx("td", { className: h.cell, colSpan: o.length, children: m }) }) }),
                o && (b || R) && /* @__PURE__ */ a.jsxs("tbody", { children: [
                  b && this._renderRows(b, j.length > 0),
                  R && j
                ] }),
                d && /* @__PURE__ */ a.jsx("tbody", { className: h.tbodyForLoader, children: /* @__PURE__ */ a.jsx("tr", { children: /* @__PURE__ */ a.jsx("td", { className: h.loaderCell, children: /* @__PURE__ */ a.jsx("div", { className: h.loader, children: /* @__PURE__ */ a.jsx(We, { small: !0 }) }) }) }) })
              ] }),
              (_ || x) && // grid: right-scroll-screen
              /* @__PURE__ */ a.jsx("div", { className: D })
            ] }),
            /* @__PURE__ */ a.jsx(se, { ariaAtomic: !0, ariaLive: "polite", children: L })
          ]
        }
      );
    }
  };
  y.defaultProps = {
    headerVariant: "",
    isLoading: !1,
    groupBy: (r) => r.group,
    groups: [],
    rowsHaveHoverEffect: void 0,
    rowKey: (r) => r.id,
    rows: [],
    stickyHeader: !1,
    stickyColumn: !1,
    stickyColumns: 0,
    horizontalScrollContainer: void 0,
    stickyGroupHeaders: !1,
    removeBottomBorder: !1,
    tabularNums: !0
  };
  let k = y;
  return Y(k, Ve);
}
const ft = Ne();
function Ge(k, y) {
  return k.reduce((e, r) => {
    const i = typeof y == "function" ? y(r) : r[y];
    return e[i] || (e[i] = []), e[i].push(r), e;
  }, {});
}
function le(k) {
  return (...y) => !k(...y);
}
function me(k) {
  return k.every((y) => !y.header);
}
export {
  Ne as G,
  ft as T,
  Pe as d
};
//# sourceMappingURL=table-Bxq8rCaY.mjs.map
